import { useState } from "react";
import { KeyRound } from "lucide-react";

import { setAccessToken, useAuthGate } from "@/api/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

/**
 * Full-screen overlay shown when any API call returns 401. The office
 * pastes its access key once; it persists in localStorage and rides on
 * every subsequent request. Reload after save so in-flight queries
 * retry with the new header.
 */
export function TokenGate() {
  const required = useAuthGate((s) => s.required);
  const [value, setValue] = useState("");

  if (!required) return null;

  function submit() {
    if (!value.trim()) return;
    setAccessToken(value);
    window.location.reload();
  }

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-ind-950/80 px-4 backdrop-blur-sm">
      <div className="w-full max-w-md rounded-xl border border-stone-200 bg-white p-6 shadow-xl">
        <div className="mb-3 flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-ind-100 text-ind-700">
            <KeyRound className="h-4 w-4" />
          </span>
          <h2 className="text-[1.05rem] font-bold text-stone-800">
            Pristupni ključ
          </h2>
        </div>
        <p className="mb-4 text-[0.85rem] text-stone-500">
          Unesi pristupni ključ koji je tvoj ured dobio uz pilot pristup.
          Ključ se sprema samo u ovom pregledniku.
        </p>
        <Label htmlFor="access-token">Ključ</Label>
        <Input
          id="access-token"
          type="password"
          autoFocus
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") submit();
          }}
          placeholder="npr. 9f2c4a…"
          className="mb-4 mt-1"
        />
        <div className="flex justify-end">
          <Button type="button" onClick={submit} disabled={!value.trim()}>
            Spremi i nastavi
          </Button>
        </div>
      </div>
    </div>
  );
}
